import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, InputField } from "components/form-inputs";
import { authService } from "services/auth.services";

const EditCustomerModal = ({ id }: any) => {
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState<{
    first_name?: string;
    last_name?: string;
    email?: string;
    phone_number?: string;
    password?: string;
    status?: string;
    role?: string;
  }>({});

  useEffect(() => {
    if (id) {
      authService.userDetails(id).then((result) => {

        setUserDetails(result)

      })
    }
  }, [id])


  const validationSchema = Yup.object({
    first_name: Yup.string().label("First Name").required(),
    last_name: Yup.string().label("Last Name").required(),
    email: Yup.string().email("Invalid email").label("Email").required(),
    phone_number: Yup.string().label("Phone Number").required(),
    password: Yup.string().label("Password").required(),
    role: Yup.string()
      .oneOf(
        ["admin", "inventory_manager", "customer_support", "logistics_manager", "customer"],
        "role must be one of [admin, inventory_manager, customer_support, logistics_manager, customer]"
      )
      .label("Role")
      .required("Role is required"),

  });

  const formik = useFormik({
    initialValues: {
      first_name: userDetails.first_name || "",
      last_name: userDetails.last_name || "",
      email: userDetails.email || "",
      phone_number: userDetails.phone_number || "",
      password: userDetails.password || "",
      status: userDetails.status || "active",
      role: userDetails.role || "customer",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true);

      if (id) {
        authService
          .updateUser(id, {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            phone_number: values.phone_number,
            status: values.status,
            role: values.role,
          })
          .then((result) => {
            setLoading(false);
            if (result.error === false) {
              window.location.reload()
            }
          })
          .catch(() => {
            setLoading(false);
          });
      }
      else {
        authService
          .register({
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            phone_number: values.phone_number,
            password: values.password,
            status: values.status,
            role: values.role,
          })
          .then((result) => {
            setLoading(false);

          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
  });

  return (
    <>
      <div
        id="add-edit-customer-modal"
        tabIndex={-1}
        aria-hidden="true"
        className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
      >
        <div className="relative max-h-full w-full max-w-2xl p-4">
          <div className="login-page">
            <div className="w-full flex items-center justify-center h-[calc(100vh)] overflow-y-auto flex-col">

              <div className="w-full max-w-md bg-white rounded-b-sm p-6 shadow-2xs border border-gray-300">
                <h2 className="text-purple-900 text-lg font-bold text-center mb-1">
                  {id ? "Edit Customer" : "Add New Customer"}
                </h2>
                <p className="text-gray-200 text-center text-base mb-4">
                  {id ? "Edit your customer details" : "Create your account"}
                </p>
                <form onSubmit={formik.handleSubmit} className="space-y-4">
                  <InputField
                    name="first_name"
                    type="text"
                    placeholder="First Name"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => formik.handleChange(e)}
                    value={formik.values.first_name}
                    required
                    onBlur={formik.handleBlur}
                    error={formik.touched.first_name && formik.errors.first_name ? formik.errors.first_name : undefined}

                  />


                  <InputField
                    name="last_name"
                    type="text"
                    placeholder="Last Name"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => formik.handleChange(e)}
                    value={formik.values.last_name}
                    onBlur={formik.handleBlur}
                    required={true}
                    error={formik.touched.last_name && formik.errors.last_name ? formik.errors.last_name : undefined}
                  />
                  <InputField
                    name="email"
                    type="email"
                    placeholder="Email"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => formik.handleChange(e)}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                    required={true}
                    error={formik.touched.email && formik.errors.email ? formik.errors.email : undefined}
                  />
                  <InputField
                    name="phone_number"
                    type="text"
                    placeholder="Phone Number"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => formik.handleChange(e)}
                    value={formik.values.phone_number}
                    onBlur={formik.handleBlur}
                    required={true}
                    error={formik.touched.phone_number && formik.errors.phone_number ? formik.errors.phone_number : undefined}
                  />
                  {!id && (
                    <InputField
                      name="password"
                      type="password"
                      placeholder="Password"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => formik.handleChange(e)}
                      value={formik.values.password}
                      onBlur={formik.handleBlur}
                      required={true}
                      error={formik.touched.password && formik.errors.password ? formik.errors.password : undefined}
                    />
                  )}

                  <div className="mb-5">
                    <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">Role</label>
                    <div className="flex flex-wrap gap-4">
                      <label className="flex items-center gap-2 text-sm text-gray-700 min-w-[140px]">
                        <input
                          type="radio"
                          name="role"
                          value="customer"
                          checked={formik.values.role === 'customer'}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          required
                        />
                        Customer
                      </label>

                      <label className="flex items-center gap-2 text-sm text-gray-700 min-w-[140px]">
                        <input
                          type="radio"
                          name="role"
                          value="admin"
                          checked={formik.values.role === 'admin'}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          required
                        />
                        Admin
                      </label>

                      <label className="flex items-center gap-2 text-sm text-gray-700 min-w-[140px]">
                        <input
                          type="radio"
                          name="role"
                          value="inventory_manager"
                          checked={formik.values.role === 'inventory_manager'}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          required
                        />
                        Inventory Manager
                      </label>

                      <label className="flex items-center gap-2 text-sm text-gray-700 min-w-[140px]">
                        <input
                          type="radio"
                          name="role"
                          value="customer_support"
                          checked={formik.values.role === 'customer_support'}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          required
                        />
                        Customer Support
                      </label>

                      <label className="flex items-center gap-2 text-sm text-gray-700 min-w-[140px]">
                        <input
                          type="radio"
                          name="role"
                          value="logistics_manager"
                          checked={formik.values.role === 'logistics_manager'}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          required
                        />
                        Logistics Manager
                      </label>
                    </div>
                    {formik.touched.role && formik.errors.role && (
                      <span className="text-red-500 text-sm mt-1">{formik.errors.role}</span>
                    )}
                  </div>
                  <Button
                    label={id ? "Update Customer" : "Add Customer"}
                    type="submit"
                    className="w-full mt-4 py-2 justify-center flex"
                    loading={loading}
                    disabled={!formik.isValid}
                  />
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCustomerModal;

